import { Modal, ModalProps, withModalConditionalRender } from '@billy/design-system'
import { ReactElement } from 'react'

import { LegalMentionsSettings } from '@features/invoicingSettings/types/legalSettings/legalMentionsSettings'

import { LegalMentionsType } from '../../../../enums/legalMentionsType'
import { LegalMentionsModalFormContextProvider } from './context/legalMentionsModalFormContext'
import { LegalMentionsModalComponent } from './elements/LegalMentionsModalComponent'

interface LegalMentionsModalProps extends ModalProps {
  defaultValues: LegalMentionsSettings
  onSubmit: (legalMentionsDetails: LegalMentionsSettings) => void
  variant: LegalMentionsType
}

const LegalMentionsComponent = ({
  defaultValues,
  onSubmit,
  variant,
  ...modalProps
}: LegalMentionsModalProps): ReactElement => {
  return (
    <Modal {...modalProps} size="s">
      <LegalMentionsModalFormContextProvider defaultValues={defaultValues} onSubmit={onSubmit} variant={variant}>
        <LegalMentionsModalComponent modalId={modalProps.id} />
      </LegalMentionsModalFormContextProvider>
    </Modal>
  )
}

export const LegalMentionsModal = withModalConditionalRender(LegalMentionsComponent)
